/**
 * @generated SignedSource<<6569113137a1e24f648ab3c6d850b078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type feedsLoaderQuery$variables = {
  club: string;
};
export type feedsLoaderQuery$data = {
  readonly club: {
    readonly communityEnabled: string | null | undefined;
  };
};
export type feedsLoaderQuery = {
  response: feedsLoaderQuery$data;
  variables: feedsLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": "communityEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COMMUNITY_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "feedsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "feedsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9c3a66ef9210fb389b954ac3c31d2e0",
    "id": null,
    "metadata": {},
    "name": "feedsLoaderQuery",
    "operationKind": "query",
    "text": "query feedsLoaderQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    communityEnabled: configuration(key: \"COMMUNITY_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "84f07c8ee0c8da9d954cb81f7bf89cbc";

export default node;
